export type WorldCupVenue = {
  name: string
  city: string
  latitude: number
  longitude: number
}

export const WORLD_CUP_2026_VENUES: WorldCupVenue[] = [
  // United States
  {
    name: 'AT&T Stadium',
    city: 'Arlington, TX',
    latitude: 32.7473,
    longitude: -97.0945,
  },
  {
    name: 'MetLife Stadium',
    city: 'East Rutherford, NJ',
    latitude: 40.8128,
    longitude: -74.0742,
  },
  {
    name: 'Hard Rock Stadium',
    city: 'Miami Gardens, FL',
    latitude: 25.958,
    longitude: -80.2389,
  },
  {
    name: 'SoFi Stadium',
    city: 'Inglewood, CA',
    latitude: 33.9535,
    longitude: -118.3392,
  },
  {
    name: 'Lumen Field',
    city: 'Seattle, WA',
    latitude: 47.5952,
    longitude: -122.3316,
  },
  {
    name: 'GEHA Field at Arrowhead',
    city: 'Kansas City, MO',
    latitude: 39.0489,
    longitude: -94.4839,
  },
  {
    name: 'NRG Stadium',
    city: 'Houston, TX',
    latitude: 29.6847,
    longitude: -95.4107,
  },
  {
    name: 'Lincoln Financial Field',
    city: 'Philadelphia, PA',
    latitude: 39.9008,
    longitude: -75.1675,
  },
  {
    name: "Levi's Stadium",
    city: 'Santa Clara, CA',
    latitude: 37.4032,
    longitude: -121.9698,
  },
  {
    name: 'Mercedes-Benz Stadium',
    city: 'Atlanta, GA',
    latitude: 33.7553,
    longitude: -84.4006,
  },
  {
    name: 'Gillette Stadium',
    city: 'Foxborough, MA',
    latitude: 42.0909,
    longitude: -71.2643,
  },
]

// Distance threshold in miles — if the user is farther than this from every
// venue we treat them as "not near" a World Cup location and re-centre the
// map on the closest venue instead of on the user.
export const VENUE_PROXIMITY_THRESHOLD_MILES = 50

export const getNearestVenue = (
  lat: number,
  lng: number,
  distanceFn: (lat1: number, lon1: number, lat2: number, lon2: number) => number
): { venue: WorldCupVenue; distanceMiles: number } => {
  let nearest = WORLD_CUP_2026_VENUES[0]
  let minDist = Infinity

  WORLD_CUP_2026_VENUES.forEach(venue => {
    const km = distanceFn(lat, lng, venue.latitude, venue.longitude)
    if (km < minDist) {
      minDist = km
      nearest = venue
    }
  })

  return { venue: nearest, distanceMiles: minDist * 0.621371 }
}

type Bounds = [number, number, number, number]

export const filterVenuesByBounds = (bounds: Bounds): WorldCupVenue[] => {
  const [west, south, east, north] = bounds
  return WORLD_CUP_2026_VENUES.filter(
    venue =>
      venue.longitude >= west &&
      venue.longitude <= east &&
      venue.latitude >= south &&
      venue.latitude <= north
  )
}
